import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {Store} from '@ngrx/store';
import {errorHappened} from '../app.types';
import {AppStore} from '../store/store';

@Injectable()
export class GlobalStoreErrorHandlerService implements ErrorHandler {

  private store!: Store<any>;

  constructor(private injector: Injector) {
  }

  handleError(error: any): void {
    this.lazyInitStore();
    console.error(error);
    this.store.dispatch(errorHappened({
      error: {
        message: error.message
      }
    }));
  }

  private lazyInitStore() {
    if (!this.store) {
      this.store = this.injector.get(Store);
    }
  }
}
